import { formatDate } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CommonServices } from "src/app/common.services";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-edit-workorder",
  templateUrl: "./admin-edit-workorder.component.html",
  styleUrls: ["./admin-edit-workorder.component.css"],
})
export class AdminEditWorkorderComponent implements OnInit {
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  workorderArray: any;
  vehicleArray: any;
  truckArray: any;
  token: any;
  document_array: any;
  last_page: any;
  total_quantity: any;
  total_wo_tons: any;
  selectCatgValue: any;
  vehiclelists: any;
  vehiclenoArray: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  @Input() minTruckEta: any;
  minTruckEtaValue = new Date();
  workOrder_id: any;
  work_order_qty: any;
  workOrderQnty: any;
  editworkform: FormGroup;
  work_order_msg: any;
  loading: boolean = false;
  dateFormat = "yyyy-MM-dd";
  workOrderDate = "dd-MM-yyyy";
  language = "en";
  unloadingQty: any;
  loadingQty: any;
  selectedWorkOrderQty: any;
  selectedDriverId: any;
  selectdCategId: any;
  constructor(
    private matdialogref: MatDialogRef<AdminEditWorkorderComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public type: any,
    private router: Router,
    private commonServices: CommonServices
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 0);
    
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.editworkform = this.formBuilder.group({
      work_order: [],
      act_ton: [""],
      work_date: [""],
      workorder_qty: [""],
      total_tons: [""],
      remaining_tons: ["", Validators.compose([Validators.required])],
      tripbooking_date: ["", Validators.compose([Validators.required])],
      truck_id: ["", Validators.compose([Validators.required])],
      driver_id: ["", Validators.compose([Validators.required])],
      driver_no: [""],
      truckwoner_id: ["", Validators.compose([Validators.required])],
      truck_name: ["", Validators.compose([Validators.required])],
      truck_no: ["", Validators.compose([Validators.required])],
      // loading_point: ["", Validators.compose([Validators.required])],
      loading_point: [""],

      unloading_point: [""],
      price_per_ton: ["", Validators.compose([Validators.required])],
      sales_order_number: [""],
      lr_number: ["", Validators.compose([Validators.required])],
      lr_date: ["", Validators.compose([Validators.required])],
      truck_eta: [""],
      tax_invoice_no: [""],
      ddc_no: [""],
    });
    this.editworkform.get("lr_date")?.valueChanges.subscribe((lrDate: Date) => {
      this.minTruckEta = lrDate ? new Date(lrDate) : null;
      if (this.editworkform.get("truck_eta")?.value && this.minTruckEta) {
        this.editworkform.get("truck_eta")?.updateValueAndValidity();
      }
    });

    this.selectChangeHandler(this.type)

    if (this.type) {
      this.editworkform.get("work_order")?.setValue(this.type.workorder_id);
      this.workOrder_id = this.type.workorder_id;
    }
    this.workOrder();
    // this.getVehicleList();
  }
  validateDecimal(event: any, controlName: string) {
    const value = event.target.value;

    // Regular expression for up to 3 decimal places
    const decimalPattern = /^\d+(\.\d{0,3})?$/;

    // Check if the input matches the pattern
    if (!decimalPattern.test(value)) {
      // Reset the invalid input field
      // this.editworkform.controls[controlName].setValue("");

      // Show a snackbar error message
      this.snackBar.open("Decimals should be up to 3 places only", "Fail", {
        duration: 5000,
      });
      return;
    }
  }

  etaValidator(control: FormControl) {
    const lrDate = this.editworkform?.get("lr_date")?.value;
    const etaDate = control.value;

    if (lrDate && etaDate && etaDate < lrDate) {
      return { etaInvalid: true };
    }
    return null;
  }

  validateTaxInvoiceInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);
    const pattern = /^[a-zA-Z0-9/-]*$/;
    if (!pattern.test(charStr)) {
      event.preventDefault();
    }
  }

  workOrder() {
    this.services.ListWorkOrder(this.token).subscribe(
      (response: any) => {
        this.vehicleArray = response.body.data;
        this.workorderArray = response.body;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  public formatWOFormDate(date: Date) {
    return formatDate(date, this.workOrderDate, this.language);
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;

    this.work_order_qty = this.total_wo_tons - this.workOrderQnty;

    // if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
    //   this.editworkform.patchValue({
    //     remaining_tons: (this.total_wo_tons - this.workOrderQnty).toFixed(3),
    //   });
    // } else {
    //   this.editworkform.patchValue({
    //     remaining_tons: this.total_wo_tons.toFixed(3),
    //   });
    //   this.snackBar.open(
    //     "Work Order Quantity Should not Exceed With Remaining Quantity",
    //     "Fail",
    //     {
    //       duration: 5000,
    //     }
    //   );
    // }
    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.editworkform.patchValue({
        remaining_tons: (this.total_quantity - this.workOrderQnty).toFixed(3),
      });
    } else {
      this.editworkform.patchValue({
        remaining_tons: this.total_quantity,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
  }
  getVehicleList() {
    this.services
      .vehicleListWithoutPagination(this.token, this.selectdCategId)
      .subscribe(
        (response: any) => {
          this.truckArray = response.body;
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public getVehiclesList(item: any) {
    this.selectCatgValue = item.value;

    this.services.GetVehicle(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.vehiclelists = response.body.data;
          this.selectedDriverId = this.vehiclelists.driverInfo[0]?._id;
          this.editworkform.patchValue({
            driver_no: this.vehiclelists?.driverInfo[0]?.mobile,
            driver_id: this.vehiclelists?.driverInfo[0]?.username,
            truck_no: this.vehiclelists?.truckOwnerInfo[0]?.mobile,
            truck_name: this.vehiclelists?.truckOwnerInfo[0]?.username,
          });
          const tested = this.truckArray.filter((item: any) => {
            return item.truck_number == this.vehiclelists.truck_number;
          });
          if (tested[0].truck_status === "trip_booked") {
            this.snackBar.open(
              "Truck Is Already Allocated Please Select Another Truck",
              "Fail",
              {
                duration: 5000,
              }
            );
            return;
          }
          if (this.vehiclelists.driverInfo.length == 0) {
            this.snackBar.open(
              "Truck Driver Not Available Please Select Another Truck",
              "Fail",
              { duration: 5000 }
            );
            return;
          }
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
          this.matdialogref.close();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  addWorkOrderTrips(event: any) {
    let loading = this.editworkform.value.loading_point;
    let unloading = this.editworkform.value.unloading_point;
    let booking_date = this.editworkform.value.tripbooking_date;
    let actual_price = this.editworkform.value.act_ton;
    let worOrderQty = this.editworkform.value.workorder_qty;

    // Helper function to validate decimal places (up to 3 allowed)
    const isValidDecimal = (value: string | number) => {
      const regex = /^\d+(\.\d{1,3})?$/;
      return regex.test(value.toString());
    };

    if (!actual_price) {
      this.snackBar.open("Please select Work Order Number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let order_qty = this.editworkform.value.workorder_qty;
    if (!order_qty) {
      this.snackBar.open("Please enter work order qty", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!booking_date) {
      this.snackBar.open("Please select tripbooking date", "Fail", {
        duration: 5000,
      });
      return;
    }
    let driver = this.editworkform.value.driver_id;
    if (!driver) {
      this.snackBar.open("Please select vehicle Number", "Fail", {
        duration: 5000,
      });
      return;
    }
    // if (this.selectedWorkOrderQty.pay_as_load_quantity == "loaded_quantity") {
    //   if (!loading) {
    //     this.snackBar.open("Please enter loading point", "Fail", {
    //       duration: 5000,
    //     });
    //     return;
    //   }
    // }
    let price_per_ton = this.editworkform.value.price_per_ton;
    if (!price_per_ton) {
      this.snackBar.open("Please enter price per ton", "Fail", {
        duration: 5000,
      });
      return;
    }
    let sales_order = this.editworkform.value.sales_order_number;
    if (!sales_order) {
      this.snackBar.open("Please enter sales order number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lr_number = this.editworkform.value.lr_number;
    if (!lr_number) {
      this.snackBar.open("Please enter LR number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let lr_date = this.editworkform.value.lr_date;
    if (!lr_date) {
      this.snackBar.open("Please select LR date", "Fail", {
        duration: 5000,
      });
      return;
    }
    // if (this.editworkform.value.truck_eta < this.editworkform.value.lr_date) {
    //   this.snackBar.open("Truck ETA cannot be greater than LR Date", "Fail", {
    //     duration: 5000,
    //   });
    //   return;
    // }
    let invoice_number = this.editworkform.value.tax_invoice_no;
    if (!invoice_number) {
      this.snackBar.open("Please enter tax invoice number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let ddc_number = this.editworkform.value.ddc_no;
    if (!ddc_number) {
      this.snackBar.open("Please enter DDC number", "Fail", {
        duration: 5000,
      });
      return;
    }

    const sampleTest = this.truckArray.filter((item: any) => {
      return item.truck_number == this.vehiclelists.truck_number;
    });

    if (sampleTest[0].truck_status === "trip_booked") {
      this.snackBar.open(
        "Truck Is Already Allocated Please Select Another Truck",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (this.vehiclelists.driverInfo.length == 0) {
      this.snackBar.open(
        "Truck Driver Not Available Please Select Another Truck",
        "Fail",
        { duration: 5000 }
      );
      return;
    }
    // if (!this.editworkform.valid || this.loading) {
    //   return; // 🚀 Prevent clicks if already loading
    // }
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly
    const tripObj = {
      remaining_tons: Number(this.editworkform.value.remaining_tons).toFixed(3),
      workorder_qty: Number(this.editworkform.value.workorder_qty),
      tripbooking_date: this.formatFormDate(
        this.editworkform.value.tripbooking_date
      ),
      truck_id: this.selectCatgValue,
      driver_id: this.selectedDriverId,
      driver_ref_id: this.selectedDriverId,

      truckwoner_id: this.vehiclelists?.truckOwnerInfo[0]?._id,
      other_details: {
        loading_point: Number(this.editworkform.value.loading_point) || 0,
        unloading_point: Number(this.editworkform.value.unloading_point) || 0,
        price_per_ton: Number(this.editworkform.value.price_per_ton),
        sales_order_number: this.editworkform.value.sales_order_number,
        lr_number: this.editworkform.value.lr_number,
        lr_date: this.formatFormDate(this.editworkform.value.lr_date),
        tax_invoice_no: this.editworkform.value.tax_invoice_no,
        ddc_no: this.editworkform.value.ddc_no,
      },
    };
    if (tripObj.workorder_qty === 0) {
      this.snackBar.open("WO Quantity cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (tripObj.other_details.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.work_order_qty >= 0 || this.workOrderQnty == this.work_order_qty) {
      this.editworkform.patchValue({
        remaining_tons: (this.total_quantity - this.workOrderQnty).toFixed(3),
      });
    } else {
      this.editworkform.patchValue({
        remaining_tons: this.total_quantity,
      });
      this.snackBar.open(
        "Work Order Quantity Should not Exceed With Remaining Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }

    if (this.editworkform.value.loading_point > worOrderQty) {
      this.snackBar.open(
        "Loading point should not more than the workOrder qty",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (this.editworkform.value.unloading_point > worOrderQty) {
      this.snackBar.open(
        "UnLoading point should not more than the workOrder qty",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    this.services
      .workOrderAddTrip(tripObj, this.token, this.type._id)
      .subscribe(
        (response: any) => {
          if (response.status == 201) {
            this.loading = true; // ✅ Disable button immediately

            this.snackBar.open(
              "Trip has been created to this work order",
              this.work_order_msg,

              {
                duration: 5000,
              }
            );
            this.commonServices.publishMessage(
              "tripAssigned",
              response.body.data
            );
            this.router.navigateByUrl("/admin/trips");
            this.matdialogref.close();
          }
          setTimeout(() => {
            this.loading = false; // ✅ Enable button after response
            (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
          }, 500);
        },
        (error) => {
          this.loading = false; // ✅ Disable button immediately

          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
            this.matdialogref.close();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public get editWorkFormControl() {
    return this.editworkform.controls;
  }

  // selectChangeHandler(item: any) {
  //   this.selectdCategId = "";
  //   this.selectdCategId = item.truck_category;
  //   this.selectedWorkOrderQty = item;
  //   this.work_order_msg = item.workorder_id;
  //   let _id = this.editworkform.value.work_order;
  //   this.services
  //     .selectedWorkOrder(_id, this.token)
  //     .subscribe((response: any) => {
  //       console.log("response", response);

  //       this.getVehicleList();
  //       this.editworkform.patchValue({
  //         act_ton: response.body.data[0]?.price_per_ton?.toFixed(2),
  //         work_date: this.formatWOFormDate(response.body.data[0]?.pickup_date),
  //       });
  //       this.total_quantity = response.body.data[0].totalLoadingPoint ?? 0;

  //       const totalTons = response.body.data[0].remaining_tons ?? 0; // Fallback to 0 if total_tons is null/undefined
  //       const totalLoadingPoint = response.body.data[0].totalLoadingPoint ?? 0; // Fallback to 0 if totalLoadingPoint is null/undefined

  //       // Calculate remaining tons
  //       // const remainingTons = (totalTons - totalLoadingPoint).toFixed(3);
  //       // const remainingTons = (totalTons - totalLoadingPoint).toFixed(3);
  //       const remainingTons = response.body.data[0].remaining_tons ?? 0;
  //       this.total_wo_tons = (totalTons - totalLoadingPoint).toFixed(3);

  //       // Patch the remaining_tons field
  //       this.editworkform.get("remaining_tons")?.patchValue(remainingTons);
  //     });

  //   // this.editworkform
  //   //   .get("remaining_tons")
  //   //   ?.patchValue(item.total_tons - item.totalLoadingPoint.toFixed(3));
  //   this.editworkform.get("total_tons")?.patchValue(item.total_tons);
  // }

  selectChangeHandler(item: any) {    
    this.selectdCategId = "";
    this.selectdCategId = item.truck_category;
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = this.editworkform.value.work_order;
    this.services
      .selectedWorkOrder(item._id, this.token)
      .subscribe((response: any) => {
        this.getVehicleList();
        this.editworkform.patchValue({
          act_ton: response.body.data[0]?.price_per_ton?.toFixed(2),
          work_date: this.formatWOFormDate(response.body.data[0]?.pickup_date),
        });
  
        // Total allocated quantity for the work order
        const totalTons = response.body.data[0].total_tons ?? 0;
        
        // Quantity already loaded in trucks
        const totalLoadingPoint = response.body.data[0].totalLoadingPoint ?? 0;
  
        // Remaining tons from previous calculations
        const previousRemainingTons = response.body.data[0].remaining_tons ?? 0;
  
        // Calculate new remaining tons
        // Added back the unloaded/rejected quantity to remaining tons
        const newRemainingTons = (totalTons - totalLoadingPoint).toFixed(2);
  
        // Patched the remaining_tons field with the calculated value
        this.editworkform.get("remaining_tons")?.patchValue(newRemainingTons);
        
        // Stored total work order tons for other calculations
        this.total_wo_tons = newRemainingTons;
        this.total_quantity = totalTons;
      });
  
    this.editworkform.get("total_tons")?.patchValue(item.total_tons);
  }

  handleWorkOrderSubmission(event: Event) {
    if (this.editworkform.value.remaining_tons === 0) {
      this.snackBar.open("WO remaining tons expired", "Close", {
        duration: 3000,
        panelClass: ["snackbar-error"],
      });

      // Reload the page after showing the snackbar
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      this.addWorkOrderTrips(event);
    }
  }

  validateUnloadingPoint() {
    const loadingPoint = this.editworkform.value.loading_point;
    const unloadingPoint = this.editworkform.value.unloading_point;

    const unloadingPointControl = this.editworkform.get("unloading_point");

    if (unloadingPointControl) {
      if (unloadingPoint > loadingPoint) {
        unloadingPointControl.setErrors({ greaterThanLoading: true });
        this.snackBar.open(
          "Unloading Point cannot be exceed with Loading Point",
          "Close",
          {
            duration: 3000,
          }
        );
      } else {
        unloadingPointControl.setErrors(null);
      }
    }
  }

  close() {
    this.matdialogref.close();
  }
  disableScroll(event: WheelEvent): void {
    event.preventDefault();
  }
}
